import React from 'react';
import './Premium.css';

// Public pricing page. Light-only, same paper as the landing.

const STRIPE_LINK = 'https://buy.stripe.com/5kQ14nc7N8oG4xBgeK2ZO01';

function checkout() {
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  const url = `${STRIPE_LINK}?prefilled_email=${encodeURIComponent(user.email || '')}&client_reference_id=${encodeURIComponent(user.uid || '')}`;
  window.location.href = url;
}

const Premium = () => (
  <div className="pr">
    <header className="pr-masthead">
      <a href="/" className="pr-brand">
        <img src="/icons/icon-128.webp" alt="" width="32" height="32" />
        <span className="dd-serif">DeepDime</span>
      </a>
      <a href="/" className="pr-back">Back to the app</a>
    </header>

    <main className="pr-main">
      <div className="pr-hero">
        <div className="dd-eyebrow">Pro · $9.99 a month</div>
        <h1 className="dd-serif">Analyse for free. Pay when you want the optimiser every day.</h1>
        <p className="dd-muted">Free covers the portfolio note and the analyst. Pro unlocks the full risk figures, more optimiser and lab runs, and the weekly news read against your holdings.</p>
        <div className="pr-cta">
          <button type="button" className="dd-btn pr-btn" onClick={checkout}>Upgrade to Pro</button>
          <span className="dd-mono dd-muted">Stripe checkout · cancel any time</span>
        </div>
      </div>

      <table className="pr-table dd-num">
        <thead><tr><th>Included</th><th className="r">Free</th><th className="r">Pro</th></tr></thead>
        <tbody>
          <tr><td>Portfolio note, Sharpe, beta</td><td className="r">Yes</td><td className="r">Yes</td></tr>
          <tr><td>VaR, expected shortfall, Sortino, drawdown</td><td className="r dd-muted">Locked</td><td className="r">Yes</td></tr>
          <tr><td>Optimiser runs</td><td className="r">5 / day</td><td className="r">50 / day</td></tr>
          <tr><td>Questions to the analyst</td><td className="r">10 / day</td><td className="r">100 / day</td></tr>
          <tr><td>Price charts</td><td className="r">10 / day</td><td className="r">100 / day</td></tr>
          <tr><td>What-if comparisons · stress scenarios</td><td className="r">20 · 5 / day</td><td className="r">200 · 50 / day</td></tr>
          <tr><td>News read against your holdings</td><td className="r dd-muted">—</td><td className="r">Weekly</td></tr>
          <tr><td>Holdings, profile, conversation history</td><td className="r">Yes</td><td className="r">Yes</td></tr>
        </tbody>
      </table>

      <div className="pr-notes dd-mono dd-muted">
        <span>No contract. Cancel from Stripe and Pro ends at the period's close.</span>
        <span>Payments are processed by Stripe; DeepDime never sees your card.</span>
      </div>
    </main>

    <footer className="pr-footer dd-mono dd-muted">DeepDime · Analysis, not financial advice.</footer>
  </div>
);

export default Premium;
